export default async function hashString(text: string | undefined) {
  const data = new TextEncoder().encode(text || "");
  const buf = data.buffer ?? data; 
  const hash = await crypto.subtle.digest('SHA-256', buf);
  // URL-safe Base64 without padding
  return btoa(String.fromCharCode(...new Uint8Array(hash)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}